import { Pencil, Trash2 } from 'lucide-react'

import { cn } from '@/utils/cn'

const btnCls =
  'flex h-7 w-7 items-center justify-center rounded-md border border-border-main text-text-tertiary hover:bg-neutral-dimmed'

interface RowActionsProps {
  itemName?: string
  onEdit?: () => void
  onDelete?: () => void
}

const RowActions = ({ itemName, onEdit, onDelete }: RowActionsProps) => (
  <div className='flex items-center gap-2'>
    {onEdit && (
      <button
        type='button'
        aria-label={itemName ? `Edit ${itemName}` : 'Edit'}
        onClick={onEdit}
        className={cn(btnCls, 'hover:text-text-primary')}
      >
        <Pencil className='h-4 w-4' />
      </button>
    )}
    {onDelete && (
      <button
        type='button'
        aria-label={itemName ? `Delete ${itemName}` : 'Delete'}
        onClick={onDelete}
        className={cn(btnCls, 'hover:text-red-400')}
      >
        <Trash2 className='h-4 w-4' />
      </button>
    )}
  </div>
)

export default RowActions
